import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import GenerateBarberShortLink from '../components/GenerateBarberShortLink';
import { generateBarberShortLink } from '../actions';
import { getById } from '../selector';

const mapStateToProps = (state, ownProps) => ({
  barber: getById(state, ownProps.barberId),
});

const mapDispatchToProps = {
  generateBarberShortLink,
};

const GenerateBarberShortLinkContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    generateShortLink: props => () => props.generateBarberShortLink(props.barberId),
  })
)(GenerateBarberShortLink);

export default GenerateBarberShortLinkContainer;
